<template>
  <div>
    <v-select
      id="select"
      ref="selectV"
      v-model="selected"
      :label="label"
      :reduce="reduce"
      :options="search ? localeOptions : options.data"
      :get-option-label="getOptionLabel"
      :placeholder="placeholder"
      :multiple="multiple"
      :disabled="disabled"
      @input="onSelected"
      solo
      @search="onSearch"
      @open="onOpen"
    >
      <template #list-footer>
        <li v-show="options.next" ref="load" class="loader">
          Loading more options...
        </li>
      </template>
    </v-select>
  </div>
</template>

<script>
import VSelect from "vue-select";

export default {
  components: {
    VSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: [Object, Array],
      default: () => [],
    },
    autoFetch: {
      type: Boolean,
      default() {
        return true;
      },
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Object,
      required: false,
      default() {
        return {
          next: null,
          timer: null,
        };
      },
    },
    getOptionLabel: {
      type: Function,
      required: false,
      default: () => {
      },
    },
    reduce: {
      type: Function,
      required: false,
      default: (v) => v,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    fetch: {
      type: Function,
      required: false,
      default: () => {
      },
    },
    pageSize: {
      type: Number,
      required: false,
      default: 15,
    },
    value: {
      type: [Array, Object, String, Number],
      default: null,
    },
    filters: {
      type: Object,
      default() {
        return {};
      },
    },
    otherProps: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      observer: null,
      selectLoading: false,
      localeOptions: [],
      searchText: "",
      selected: null,
      nextPage: 1,
      search: null,
      select: null,
      oldPosition: null,
    };
  },
  watch: {
    value(newValue) {
      this.selected = newValue;
    },
    // options(newValue) {
    //   this.localeOptions = newValue.results || newValue.data;
    // },
    filters: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadOptions();
  },
  methods: {
    onSelected(value) {
      this.$emit("input", value);
    },
    onOpen() {
      const {uid} = this.$refs.selectV;
      setTimeout(() => {
        this.select = document.getElementById(`vs${uid}__listbox`);
        this.select.addEventListener("scroll", () => {
          if (
            this.select.scrollTop + this.select.clientHeight >=
            this.select.scrollHeight - 1
          ) {
            this.loadOptions();
            this.oldPosition = this.select.scrollTop;
          }
        });
      }, 500);
    },
    async onSearch(search, loading) {
      loading(true);
      this.search = search;

      return new Promise(async (resolve, reject) => {
        if (!this.search) {
          loading(false);
          return resolve();
        }
        this.nextPage = 1;
        await this.fetch({
          ...this.filters,
          search: this.search,
          page: this.nextPage,
          page_size: 15,
        }).then(res => {

          this.localeOptions = res.data
          this.nextPage = res.next;
        }).finally(() => {
          resolve()
        })
        // this.localeOptions = this.options.results || this.options.data;

        this.$nextTick(() => {
          loading(false);
          this.onOpen();
        });
      })

    },

    refresh() {
      this.nextPage = 1;
      this.localeOptions = [];
      this.clearSearch();
      this.loadOptions();
    },

    async loadOptions() {
      if (this.nextPage) {
        await this.fetch({
          ...this.filters,
          search: this.search,
          page: this.nextPage,
          page_size: 15,
        });
        if (this.nextPage !== this.options.next) {
          this.nextPage = this.options.next;
          // this.localeOptions.push(
          //   ...(this.options.results || this.options.data)
          // );
          this.$nextTick(() => {
            const {uid} = this.$refs.selectV;
            document.getElementById(`vs${uid}__listbox`).scrollTop =
              this.oldPosition;
          });
        }
      }
    },

    clearSearch() {
      this.$refs.selectV.search = "";
    },
  },
};
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
